<div
  [formGroup]="form"
  *ngIf="form"
>
  <mable-input
    label="Your offer (per hour)"
    icon="fa-dollar-sign-solid"
    class="ion-no-margin"
    [ngClass]="{ 'has-info': form.value.netRate }"
    [hasError]="form.get('rate').showError()"
  >
    <div class="description">
      <p>Includes 10% worker service fee.</p>
    </div>
    <ion-input
      type="text"
      formControlName="rate"
      max="9999.99"
      [min]="minimumRate"
      step="1"
      data-testid="sp-rate-offer-input"
    >
    </ion-input>
    <div class="warn">
      <p *ngIf="form.get('rate').errors?.required">Please enter the offer amount.</p>
      <p
        *ngIf="!form.get('rate').errors?.pattern && form.get('rate').errors?.max"
        data-testid="rate-above-max-error-text"
      >
        Amount must be less than $10,000.
      </p>
      <p
        *ngIf="!form.get('rate').errors?.pattern && form.get('rate').errors?.min"
        data-testid="rate-below-min-error-text"
      >
        Offer a minimum rate of ${{ minimumRate }}
        for active support under our terms of use.
      </p>
      <p
        *ngIf="form.get('rate').errors?.pattern"
        data-testid="wrong-format-error-text"
      >
        Provide a numeric value
      </p>
    </div>
    <p
      class="info"
      *ngIf="!form.get('rate').showError() && form.value.netRate"
      data-testid="net-rate-text"
    >
      Net rate you will be paid is ${{ form.value.netRate }}
    </p>
  </mable-input>
  <ng-container *ngIf="form.get('showCapRateBanner').value">
    <app-ndis-price-limit-alert
      [priceLimitAlertData]="priceLimitAlertData"
      [rateData]="form.value"
    >
    </app-ndis-price-limit-alert>
  </ng-container>
</div>
